import { render, staticRenderFns } from "./jy-outboundScanBoxList.vue?vue&type=template&id=21a11ff1&scoped=true&"
import script from "./jy-outboundScanBoxList.vue?vue&type=script&lang=js&"
export * from "./jy-outboundScanBoxList.vue?vue&type=script&lang=js&"
import style0 from "./jy-outboundScanBoxList.vue?vue&type=style&index=0&id=21a11ff1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a11ff1",
  null
  
)

export default component.exports